// src/components/quality/CustomerAssessmentCard.js
import { useState } from 'react';
import useAuth from '../../hooks/useAuth';
import api from '../../services/api';

const CustomerAssessmentCard = ({ assessment, projectSelect, onEdit, onAssessmentDeleted }) => {
  const { user } = useAuth();
  const [expanded, setExpanded] = useState(false);

  // Проверка прав на редактирование
  const roleNames = new Set(user?.roles?.map(r => r.name) || []);
  const hasQcCustomer = roleNames.has('qc_customer');
  const hasAdminOrCustomer = roleNames.has('admin') || roleNames.has('customer');
  const hasProjectAccess = user.projects && user.projects.some(p => p.id === projectSelect);
  
  const canEdit = user.superuser === true ||
                 (hasQcCustomer && hasAdminOrCustomer && hasProjectAccess);
  
  // Проверка прав на удаление (только для superuser)
  const canDelete = user.superuser === true;

  const toggleExpand = () => setExpanded(!expanded);

  const handleDeleteAssessment = async (assessment) => {
    if (!window.confirm('Вы уверены, что хотите удалить эту оценку от клиента? Это действие нельзя отменить.')) {
      return;
    }
    
    try {
      await api.delete(`/quality/assessment-customer/${assessment.id}`);
      // Обновляем список оценок через callback
      onAssessmentDeleted();
    } catch (error) {
      console.error('Ошибка при удалении оценки от клиента:', error);
      window.showToast('Не удалось удалить оценку от клиента');
    }
  };

  return (
    <div className="assessment-card">
      <div className="card-header" onClick={toggleExpand} style={{cursor: 'pointer'}}>
        <h4>{assessment.operator_name}</h4>
        <small>
          {assessment.call_datetime ? (() => {
            const date = new Date(assessment.call_datetime);
            date.setHours(date.getHours() + 3);
            return date.toLocaleString('ru-RU', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false,
            });
          })() : '—'}
          
          <>
            <span className={assessment.needs_os ? 'badge bg-warning' : 'badge bg-success'} style={{ marginLeft: '10px', fontSize: '0.8em', padding: '0.25em 0.4em' }}>
              {assessment.needs_os ? 'Требуется ОС' : 'Не требуется ОС'}
            </span>
            {assessment.needs_os && (
              <span className={assessment.os_given ? 'badge bg-success' : 'badge bg-danger'} style={{ marginLeft: '10px', fontSize: '0.8em', padding: '0.25em 0.4em' }}>
                {assessment.os_given ? 'Дана ОС' : 'Не дана ОС'}
              </span>
            )}
          </>
        </small>
        <div>
          <strong>Проверяющий:</strong> {assessment.assessor_name ? assessment.assessor_name : '—'}
        </div>
        {canEdit && (
            <button className="btn btn-sm btn-secondary" onClick={(e) => {
              e.stopPropagation();
              onEdit(assessment);
            }}>
              Редактировать
            </button>
        )}
        {canDelete && (
            <button className="btn btn-sm btn-danger" onClick={(e) => {
              e.stopPropagation();
              handleDeleteAssessment(assessment);
            }}>
              Удалить
            </button>
        )}
        <span>{expanded ? '▲' : '▼'}</span>
      </div>

      {expanded && (
          <div className="card-body">
            <div className="info-grid">
              <div><strong>Дата звонка:</strong> {assessment.call_datetime ? (() => {
                const date = new Date(assessment.call_datetime);
                date.setHours(date.getHours() + 3);
                return date.toLocaleString('ru-RU', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: false,
                });
              })() : '—'}</div>
              <div><strong>Дата оценки:</strong> {assessment.assessment_date ? (() => {
                const date = new Date(assessment.assessment_date);
                date.setHours(date.getHours() + 3);
                return date.toLocaleString('ru-RU', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour12: false,
                });
              })() : '—'}</div>
              <div><strong>Номер телефона:</strong> {assessment.phone_number || '—'}</div>
              <div><strong>Вопрос клиента:</strong> {assessment.customer_question || '—'}</div>
              <div><strong>Тема:</strong> {assessment.theme || '—'}</div>
              <div><strong>Ответ оператора:</strong> {assessment.operator_response || '—'}</div>
              <div><strong>Подтема:</strong> {assessment.subtheme || '—'}</div>
              <div><strong>Внутренний комментарий:</strong> {assessment.internal_comment || '—'}</div>
              <div><strong>Комментарий для отправки оператору:</strong> {assessment.comment_for_send || '—'}</div>
              {assessment.needs_os && (
                  <>
                    <div><strong>ОС:</strong> {assessment.os_given ? 'Дана' : 'Не дана'}</div>
                    {assessment.os_datetime && (
                        <div><strong>Дата ОС:</strong> {(() => {
                          const date = new Date(assessment.os_datetime);
                          date.setHours(date.getHours() + 3);
                          return date.toLocaleString('ru-RU', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour12: false,
                          });
                        })()}</div>
                    )}
                  </>
              )}
            </div>
          </div>
      )}
    </div>
  );
};

export default CustomerAssessmentCard;